<template>
  <div>
    <v-data-table
        dense
        :headers="columns"
        :items="getItemList"
        item-key="history_id"
        class="elevation-1"
        :options.sync="options"
        @update:options="updateOptions"
        :server-items-length="totalRecords"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': [10, 15, 20, 50, 100]
        }"
        :height="height"
        fixed-header
        @click:row="onClickRow"
    >
      <template
          v-for="column in columns"
          v-slot:[`item.${column.value}`]="{ item }"
      >
        <slot :name="[`item.${column.value}`]" :item="item">
          <v-row>
          <v-badge v-if="isFieldChanged(column, item) && item[column.value] == null" color="red" dot> </v-badge>
          <div :class="{ 'low-height-cell' : item.history_id !== selectedItemId, 'changed-field': isFieldChanged(column, item)}"
            v-html="item[column.value]">
<!--            <span v-if="Array.isArray(item[column.value])" >-->
<!--              <p v-for="itemArray in item[column.value]" :key="itemArray.history_id">-->
<!--                {{ itemArray }}-->
<!--              </p>-->
<!--            </span>-->
<!--            <span v-else>-->
<!--              {{ item[column.value] }}-->
<!--            </span>-->
          </div>
            </v-row>
        </slot>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
            color="warning"
            @click="onRestore(item)"
        >
          mdi-backup-restore
        </v-icon>
      </template>
      <template v-slot:item.history_date="{ item }">
        {{ item.history_date | moment("YY.MM.DD HH:mm") }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';

export default {
  name: 'StoreFileHistory',
  props: {
    'storeFileItemId': [String, Number],
    'hide-default-footer': {type: Boolean, default: false},
    'height': {
      type: [Number, Function], default: function () {
        return this.$vuetify.breakpoint.height - 800
      }
    },
  },

  components: {},

  computed: {
    ...mapGetters('StoreFileHistory', ['getItemList', 'getColumns']),
    ...mapFields('StoreFileHistory', ['options', 'totalRecords', 'options.page', 'restoreLoading', 'loading']),
  },

  methods: {
    ...mapActions('StoreFileHistory', ['fetchItemList', 'fetchRestoreItem']),
    ...mapActions('StoreFileList', {'fetchStoreFileItemList': 'fetchItemList'}),
    onResize() {
      this.windowHeight = (window.innerHeight - this.subheight) + 'px'
    },
    onUpdateSearchTerm: debounce(function () {
      this.options.page = 1
      this.fetchItemList(this.storeFileItemId)
    }, 800),

    updateOptions() {
      this.fetchItemList(this.storeFileItemId)
    },
    onClickRow(item, event) {
      if (this.selectedItemId === item.history_id)
        this.selectedItemId = null
      else
        this.selectedItemId = item.history_id
    },
    isFieldChanged(column, item) {
      // console.log('isFieldChanged', item)
      const column_name = column.value.split('__')[0]
      return column_name in item['changed_fields']
    },
    async onRestore(Item) {
      console.log('onRestore', Item)
      await this.fetchRestoreItem(Item);
      await this.fetchItemList(this.storeFileItemId);
      await this.fetchStoreFileItemList(Item.store_doc);
    },
  },

  async mounted() {
    window.addEventListener("resize", this.onResize)
    await this.fetchItemList(this.storeFileItemId);
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  data() {
    return {
      selectedItemId: null,
      windowHeight: (window.innerHeight - this.subheight) + 'px',
      columns: [
        {text: '', value: 'actions', sortable: false, divider: true, width: 50},
        // {text: 'Сhanged fields', value: 'changed_fields', sortable: false, divider: true, width: 200, brief: true,},
        {text: 'History date', value: 'history_date', sortable: true, divider: true, width: 100},
        {text: 'History user', value: 'history_user__username', sortable: true, divider: true, width: 100},
        // {text: 'Created on', value: 'created_on', sortable: true, filterable: true, divider: true, width:100},
        // {text: 'Edited by', value: 'edited_by__username', sortable: true, filterable: true, divider: true, width: 100},
        // {text: 'Edited on', value: 'edited_on', sortable: true, filterable: true, divider: true, width: 140},
        // {text: 'Created by', value: 'created_by__username', sortable: true, filterable: true, divider: true, width:100},
        {text: 'Alive', value: 'alive', sortable: true, filterable: true, divider: true, width: 100},
        {text: 'Source type', value: 'source_type', sortable: true, filterable: true, divider: true, width: 100},
        {text: 'Title', value: 'title', sortable: true, filterable: true, divider: true, width: 400},
        {text: 'File', value: 'file__filename', sortable: false, divider: true, width: 200},
        // {text: 'Store doc', value: 'store_doc', sortable: true, divider: true},
        // {text: 'Content', value: 'content', sortable: false, divider: true},
      ],

    }
  }
}
</script>

<style scoped lang="scss">
.changed-field {
  color: darkred;
  //background-color: #FF8A80;
}

.low-height-cell {
  max-height: 3em;
  overflow-y: hidden;
  //background-color: red;
}
</style>
